import React, {useEffect, useRef} from 'react';
import {useMainState} from "../MainStateMachineProvider";
import {Frame} from "../Frame/Frame";

import css from "./FrameManager.module.css"

const FrameManager = () => {

    const state = useMainState();
    const lastItemRef = useRef(null);
    
    // Safely extract dependencies for useEffect
    const {
        currentCardIndex = 0, 
        currentScenarioIndex = 0,
    } = state?.context || {};

    useEffect(() => {
        if (lastItemRef.current) {
            lastItemRef.current.scrollIntoView({behavior: "smooth"});
        }
    }, [currentScenarioIndex, currentCardIndex]);

    // Early return after hooks
    if (!state || !state.context || Object.keys(state.context).length === 0) return null;

    const {
        currentIndex = 0, 
        data = [],
        scenario = []
    } = state.context;

    const currentData = data[currentIndex] || {};
    const title = currentData.title || "";
    const scenarioItems = currentData.scenarioItems || [];

    const renderFrames = ({scenario, item, cardTextNumber}) =>
        (<div key={item.id} className={css.card}>
            {item.id <= currentCardIndex && <div className={css.badge}>{cardTextNumber}</div>}
            {scenario.map(s => (
                <Frame
                    key={s.id}
                    dataItem={item}
                    cardIndex={item.id}
                    scenarioIndex={s.id}
                    currentScenario={s}
                    currentCardIndex={currentCardIndex}
                    currentScenarioIndex={currentScenarioIndex}
                />
            ))}
        </div>)


    return (
        <>
            {title && <div className={css.text}>{title}</div>}
            <div>
                {scenarioItems && scenario && scenarioItems.map((item, index) => (renderFrames({
                    scenario,
                    item,
                    cardTextNumber: `${index + 1}/${scenarioItems.length}`
                })))}
            </div>
            <div ref={lastItemRef}></div>
        </>
    );
};

export {FrameManager};